// let display = "none"

export const Inputs = [
    [
        // {
        //     type: "select",
        //     name: "UserType",
        //     label: { ar: "اختر النوع", en: "Choose type" },
        //     title: { ar: "", en: "" },
        //     optionTitle: { ar: "النوع", en: "Type" },
        //     options: [
        //         { value: "TEACHER", title: { ar: "مدرس", en: "Teacher" } },
        //         { value: "ASSISTANT", title: { ar: "مساعد", en: "Assistant" } },
        //         { value: "STUDENT", title: { ar: "طالب", en: "Student" } },
        //         { value: "PARENT", title: { ar: "ولي امر", en: "Parent" } },
        //     ],
           
        // },
        {
            type: "text",
            name: "firstName",
            label: { ar: "الاسم الاول", en: "First name" },
            placeholder: "",
            size: { lg: "6", md: "6" }
        },
        {
            type: "text",
            name: "lastName",
            label: { ar: "الاسم الاخير", en: "Last name" },
            placeholder: "",
            size: { lg: "6", md: "6" }
        },
        {
            type: "email",
            name: "email",
            label: { ar: "البريد الالكتروني", en: "Email" },
            placeholder: "NewConcept@gmail.com",
            size: { lg: "6", md: "6" }
        },
        {
            type: "text",
            name: "UserName",
            label: { ar: "اسم المستخدم", en: "Username" },
            placeholder: "",
            size: { lg: "6", md: "6" }
        },
        {
            type: "password",
            label: { ar: "كلمة المرور", en: "Password" },
            placeholder: "**********",
            name: "password",
            size: { lg: "6", md: "6" }
        },
        {
            type: "password",
            label: { ar: 'تأكيد كلمة المرور', en: "Password confirmation" },
            placeholder: "**********",
            name: "confirmpassword",
            size: { lg: "6", md: "6" }
        },
        {
            type: "text",
            name: "address",
            label: { ar: "العنوان", en: "Address" },
            placeholder: "",
            size: { lg: "6", md: "6" }
        },
        {
            type: "text",
            inputType:"number",
            name: "phone",
            label: { ar: "الهاتف", en: "Phone" },
            placeholder: "",
            size: { lg: "6", md: "6" },
        },
    ]

];


export const VisitorInput = [
    [
        {
            type: "select",
            name: "type",
            label: { ar: "اسم المرحلة", en: "Level's Name" },
            title: { ar: "", en: "" },
            optionTitle: { ar: "", en: "" },
            options: [
                { value: "TEACHER", title: { ar: "مدرس", en: "Teacher" } },
                { value: "ASSISTANT", title: { ar: "مساعد", en: "Assistant" } },
                { value: "STUDENT", title: { ar: "طالب", en: "Student" } },
                { value: "GUARDIAN", title: { ar: "ولي امر", en: "Parent" } },
            ],

        },
        {
            type: "select",
            name: "type",
            label: { ar: "اسم الصف", en: "Class's Name" },
            title: { ar: "", en: "" },
            optionTitle: { ar: "", en: "" },
            options: [
                { value: "TEACHER", title: { ar: "مدرس", en: "Teacher" } },
                { value: "ASSISTANT", title: { ar: "مساعد", en: "Assistant" } },
                { value: "STUDENT", title: { ar: "طالب", en: "Student" } },
                { value: "GUARDIAN", title: { ar: "ولي امر", en: "Parent" } },
            ],

        },
    ]
];

